import { render, staticRenderFns } from "./EaseComponent.vue?vue&type=template&id=06c39e77"
import script from "./EaseComponent.vue?vue&type=script&lang=js"
export * from "./EaseComponent.vue?vue&type=script&lang=js"
import style0 from "./EaseComponent.vue?vue&type=style&index=0&id=06c39e77&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports